import { REQUEST_LIST_SENSORS, RESPONSE_LIST_SENSORS, REQUEST_LIST_SENSORS_FAILURE } from "../actions/listSensorsActions";

import { states } from "./queriesStates";

const initialState = {
  listSensorsDataState: states.NOT_REQUESTED,
  listSensors: { sensors: [] },
  errors: [],
};

const listSensorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_LIST_SENSORS:
      return Object.assign({}, state, {
        listSensorsDataState: states.REQUEST,
        listSensors: { sensors: [] },
      });
    case RESPONSE_LIST_SENSORS:
      return Object.assign({}, state, {
        listSensorsDataState: states.READY,
        listSensors: action.data,
      });
    case REQUEST_LIST_SENSORS_FAILURE:
      return Object.assign({}, state, {
        listSensorsDataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default listSensorsReducer;
